"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: points/points-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fpoints%2Fpoints-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointsServiceClient = exports.CashBundle = exports.CashBundlesResponseBundlesEntry = exports.CashBundlesResponse = exports.CashBundlesRequest = exports.EvaluateResponse = exports.EvaluateRequest = exports.RedeemResponse = exports.RedeemCashBundle = exports.RedeemPurchase = exports.RedeemRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const image_1 = require("../common/image");
const protobufPackage = 'com.step.points.proto';
function createBaseRedeemRequest() {
    return { referenceId: '', purchase: undefined, bundle: undefined };
}
exports.RedeemRequest = {
    fromJSON(object) {
        const message = {
            referenceId: isSet(object.referenceId) ? globalThis.String(object.referenceId) : '',
        };
        if (isSet(object.purchase)) {
            message.purchase = exports.RedeemPurchase.fromJSON(object.purchase);
        }
        if (isSet(object.bundle)) {
            message.bundle = exports.RedeemCashBundle.fromJSON(object.bundle);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.purchase !== undefined) {
            obj.purchase = exports.RedeemPurchase.toJSON(message.purchase);
        }
        if (message.bundle !== undefined) {
            obj.bundle = exports.RedeemCashBundle.toJSON(message.bundle);
        }
        return obj;
    },
    create(base) {
        return exports.RedeemRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemRequest();
        message.referenceId = object.referenceId ?? '';
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.RedeemPurchase.fromPartial(object.purchase)
            : undefined;
        message.bundle = (object.bundle !== undefined && object.bundle !== null)
            ? exports.RedeemCashBundle.fromPartial(object.bundle)
            : undefined;
        return message;
    },
};
function createBaseRedeemPurchase() {
    return { accountId: '', paymentId: '' };
}
exports.RedeemPurchase = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== undefined && message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.RedeemPurchase.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemPurchase();
        message.accountId = object.accountId ?? '';
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseRedeemCashBundle() {
    return { bundleId: '' };
}
exports.RedeemCashBundle = {
    fromJSON(object) {
        const message = {
            bundleId: isSet(object.bundleId) ? globalThis.String(object.bundleId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.bundleId !== '') {
            obj.bundleId = message.bundleId;
        }
        return obj;
    },
    create(base) {
        return exports.RedeemCashBundle.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemCashBundle();
        message.bundleId = object.bundleId ?? '';
        return message;
    },
};
function createBaseRedeemResponse() {
    return { paymentId: '' };
}
exports.RedeemResponse = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.RedeemResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemResponse();
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseEvaluateRequest() {
    return { purchase: undefined };
}
exports.EvaluateRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.purchase)) {
            message.purchase = exports.RedeemPurchase.fromJSON(object.purchase);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.purchase !== undefined) {
            obj.purchase = exports.RedeemPurchase.toJSON(message.purchase);
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateRequest();
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.RedeemPurchase.fromPartial(object.purchase)
            : undefined;
        return message;
    },
};
function createBaseEvaluateResponse() {
    return { amount: undefined };
}
exports.EvaluateResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateResponse();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        return message;
    },
};
function createBaseCashBundlesRequest() {
    return {};
}
exports.CashBundlesRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CashBundlesRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCashBundlesRequest();
        return message;
    },
};
function createBaseCashBundlesResponse() {
    return { bundles: {} };
}
exports.CashBundlesResponse = {
    fromJSON(object) {
        const message = {
            bundles: isObject(object.bundles)
                ? Object.entries(object.bundles).reduce((acc, [key, value]) => {
                    acc[key] = exports.CashBundle.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.bundles) {
            const entries = Object.entries(message.bundles);
            if (entries.length > 0) {
                obj.bundles = {};
                entries.forEach(([k, v]) => {
                    obj.bundles[k] = exports.CashBundle.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.CashBundlesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCashBundlesResponse();
        message.bundles = Object.entries(object.bundles ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.CashBundle.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseCashBundlesResponseBundlesEntry() {
    return { key: '', value: undefined };
}
exports.CashBundlesResponseBundlesEntry = {
    fromJSON(object) {
        const message = {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
        };
        if (isSet(object.value)) {
            message.value = exports.CashBundle.fromJSON(object.value);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = exports.CashBundle.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.CashBundlesResponseBundlesEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCashBundlesResponseBundlesEntry();
        message.key = object.key ?? '';
        message.value = (object.value !== undefined && object.value !== null)
            ? exports.CashBundle.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseCashBundle() {
    return {
        pointsAmount: amount_1.Amount.fromPartial({}),
        rewardAmount: amount_1.Amount.fromPartial({}),
        image: image_1.Image.fromPartial({}),
    };
}
exports.CashBundle = {
    fromJSON(object) {
        const message = {
            pointsAmount: isSet(object.pointsAmount)
                ? amount_1.Amount.fromJSON(object.pointsAmount)
                : amount_1.Amount.fromPartial({}),
            rewardAmount: isSet(object.rewardAmount)
                ? amount_1.Amount.fromJSON(object.rewardAmount)
                : amount_1.Amount.fromPartial({}),
            image: isSet(object.image) ? image_1.Image.fromJSON(object.image) : image_1.Image.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.pointsAmount !== undefined) {
            obj.pointsAmount = amount_1.Amount.toJSON(message.pointsAmount);
        }
        if (message.rewardAmount !== undefined) {
            obj.rewardAmount = amount_1.Amount.toJSON(message.rewardAmount);
        }
        if (message.image !== undefined) {
            obj.image = image_1.Image.toJSON(message.image);
        }
        return obj;
    },
    create(base) {
        return exports.CashBundle.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCashBundle();
        message.pointsAmount = (object.pointsAmount !== undefined && object.pointsAmount !== null)
            ? amount_1.Amount.fromPartial(object.pointsAmount)
            : amount_1.Amount.fromPartial({});
        message.rewardAmount = (object.rewardAmount !== undefined && object.rewardAmount !== null)
            ? amount_1.Amount.fromPartial(object.rewardAmount)
            : amount_1.Amount.fromPartial({});
        message.image = (object.image !== undefined && object.image !== null)
            ? image_1.Image.fromPartial(object.image)
            : image_1.Image.fromPartial({});
        return message;
    },
};
/**
 * Points service.
 */
class PointsServiceClient {
    rpc;
    name = 'com.step.points.proto.PointsService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/points';
    methods = [{
            name: 'Redeem',
            requestType: exports.RedeemRequest,
            responseType: exports.RedeemResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'Evaluate',
            requestType: exports.EvaluateRequest,
            responseType: exports.EvaluateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CashBundles',
            requestType: exports.CashBundlesRequest,
            responseType: exports.CashBundlesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Redeem an item using available to the user points balance.
     */
    redeem(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Evaluate how much points it will take to redeem an item
     */
    evaluate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns list of available cash bundles
     */
    cashBundles(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.PointsServiceClient = PointsServiceClient;
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=points-service.js.map